import React from 'react';
import styled from 'styled-components';

import {StyledSpinner} from '../styles/StyledSpinner';

const Spinner = () => <StyledSpinner/>

export default Spinner;
